import errorManager from '@/rollbar.js';

const changedLabDone = () => {
  if ($('#guest_exam_done').is(':checked')) {
    $('#full_execute').removeClass('inactive');
    $('#full_execute').addClass('active');
  } else {
    if ($('#guest_exam_date').val() === '') {
      $('#full_execute').removeClass('active');
      $('#full_execute').addClass('inactive');
    }
  }
};

const changedRefDone = () => {
  if ($('#guest_exam_date').val() !== '') {
    $('#full_execute').removeClass('inactive');
    $('#full_execute').addClass('active');
    $('#report').removeClass('inactive');
    $('#report').addClass('active');
  } else {
    $('#report').removeClass('active');
    $('#report').addClass('inactive');
  }
};

const init = () => {
  try {
    $(document).on('input', '#guest_exam_done', changedLabDone);
    $(document).on('change paste keyup', '#guest_exam_date', changedRefDone);
  } catch (e) {
    errorManager(e);
  }
};

window.GuestExam = {
  init: init,
};
